import * as React from "react";

import { Navigate, Outlet, useLocation } from "react-router-dom";

//import { Cookie } from "@mui/icons-material";
import menuItem from "./Layout/menuItem.jsx";
function ProtectedPage() {
  return <h3>Protected</h3>;
}

const AuthRoute = ({ children }) => {
  let location = useLocation();
  let user = JSON.parse(localStorage.getItem("QCAPPuser"));
  let locationArr = location.pathname.split("/").reverse();
  let lastPath = "";
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} />;
  }
  for (const path of locationArr) {
    if (
      isNaN(parseInt(path)) &&
      menuItem.some((group) => group.menu.some((menu) => menu.path === path))
    ) {
      lastPath = path;
      break;
    }
  }
  if (locationArr[0] === "" && user !== null) {
    if (
      user.role === "inspector" ||
      user.role === "approver" ||
      user.role === "checker"
    ) {
      return <Navigate to={`/layout/paper`} />;
    } else if (
      user.role === "release" ||
      user.role === "checker_revise" ||
      user.role === "approver_revise"
    ) {
      return <Navigate to={`/layout/part`} />;
    } else {
      return <Navigate to={`/layout/pending`} />;
    }
  }
  let checkRole = menuItem.some((group) => {
    const result = group.menu.some((menu) => {
      // console.log("in group", menu);
      let pathName = menu.path.split("/").reverse()[0];
      let checkSome = menu.role.some((role) => {
        return role === user.role;
      });

      let checkPath = pathName === lastPath;
      // console.log(checkSome, checkPath, pathName, lastPath);
      return checkSome && checkPath;
    });
    // console.log(`${group.groupName}`, result);
    return result;
  });
  // console.log("checkRole", checkRole);
  return lastPath === "profile" || (user && checkRole) ? (
    <Outlet />
  ) : (
    <Navigate to="/login" state={{ from: location }} />
  );
};
export { AuthRoute, ProtectedPage };
